import React from "react";

const CARDS = `${import.meta.env.BASE_URL}img/cards`;

/**
 * Reference result body for Bollywood Casino (btable / btable2 / vbtable):
 * the drawn card (unless a back "1") + rdesc "winner#odd#dulha-dulhan/barati#color#card".
 */
export default function BtableResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const rows = [
    ["Winner", desc[0]],
    ["Odd", desc[1]],
    ["Dulha Dulhan/Barati", desc[2]],
    ["Color", desc[3]],
    ["Card", desc[4]],
  ];
  return (
    <div className="row row5">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center" style={{ alignItems: "flex-end" }}>
              <div className="casino-result-cards">
                {cards[0] !== "1" && (
                  <div className="casino-result-cards-item">
                    <img src={`${CARDS}/${cards[0]}.png`} alt="" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {rows.map(([label, value], i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{value}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
